import Hero from '../components/Hero.jsx';
import About from '../components/About.jsx';
import Skills from '../components/Skills.jsx';
import Contact from '../components/Contact.jsx';
import useScrollReveal from '../hooks/useScrollReveal.jsx';
import AboutWork from '../components/AboutWork.jsx';
import { useEffect } from 'react';

const Home = () => {
    useScrollReveal();
    useEffect(() => {
        window.scrollTo(0, 0);
        if (window.location.hash) {
            setTimeout(() => {
                const id = window.location.hash.substring(1);
                const element = document.getElementById(id);
                if (element) {
                    const offsetTop = element.offsetTop - 80;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                }
            }, 100);
        }
    }, []);

    return (
        <div className="home-page">
            <Hero />
            <About />
            <AboutWork projects={projects} />
            <Skills />
            <Contact />
        </div>
    );
};
const projects = [
    {
        id: 'ecommerce-platform',
        title: 'E-Commerce Platform',
        category: 'Web Design',
        year: '2024',
        description: 'A modern e-commerce solution with seamless user experience and stunning visuals.',
        tags: ['UI/UX', 'React', 'Node.js'],
        className: 'project-1'
    },
    {
        id: 'brand-identity',
        title: 'Brand Identity System',
        category: 'Branding',
        year: '2024',
        description: 'Complete brand identity for a tech startup, from logo to guidelines.',
        tags: ['Branding', 'Design System', 'Figma'],
        className: 'project-2'
    },
    {
        id: 'fitness-app',
        title: 'Fitness Tracking App',
        category: 'Mobile App',
        year: '2023',
        description: 'Mobile application for tracking workouts and nutrition with AI insights.',
        tags: ['Mobile', 'React Native', 'AI'],
        className: 'project-3'
    },
    {
        id: 'fitness-app',
        title: 'Fitness Tracking App',
        category: 'Mobile App',
        year: '2023',
        description: 'Mobile application for tracking workouts and nutrition with AI insights.',
        tags: ['Mobile', 'React Native', 'AI'],
        className: 'project-3'
    }
];
export default Home;
